import clsx from "clsx";
import React from "react";
import { useIntl } from "react-intl";

import { decorateMessage } from "../../utils/decorateMessage";
import { svgIcon } from "../../utils/svgProvider";

interface AlertProps {
	index?: number;
	level: string;
	["data-testid"]?: string;
	messageKey: string;
	messageValues?: any;
	onAlertClose?: (index: number) => void;
}

export const Alert = ({
	index,
	level,
	messageKey,
	"data-testid": dataTestId,
	messageValues = {},
	onAlertClose,
}: AlertProps) => {
	const { formatMessage } = useIntl();

	const translatedMessage =
		Object.keys(messageValues)?.length > 0
			? decorateMessage({
					message: formatMessage({ id: messageKey }),
					messageValues,
				})
			: null;

	return (
		<div
			className={clsx({
				"alert-wrapper": true,
				[level]: true,
			})}
			data-testid={dataTestId || `alert-bar-${level}`}
		>
			<div className="alert-header">
				<span className="alert-icon">{svgIcon[level]}</span>
			</div>
			<div className="alert-content">
				<div
					className="alert-content-text"
					dangerouslySetInnerHTML={{
						__html:
							translatedMessage ||
							formatMessage({
								id: messageKey,
							}),
					}}
				/>
				{onAlertClose && (
					<button
						className="alert-close close-button"
						role="button"
						onClick={() => onAlertClose(index)}
					>
						{svgIcon.close}
					</button>
				)}
			</div>
		</div>
	);
};

export default Alert;
